import React, { useEffect, useState } from 'react';
import Nav from '../../components/Nav';
import DinamicTable from '../../components/DinamicTable';
import DashboardSidebar from '../../components/DashboardSidebar';
import ApiService from '../../services/ApiService';

const SubscriptionList = () => {

    const [active, setActive] = useState(true);
    const [subscriptions, setSubscriptions] = useState([]);
    const [filter, setFilter] = useState({ page: 1, pages: 0, limit: 5, isLoading: false, search: '' });

    const tableColumns = ["#", "Title", "Type", "Status", "Discount", "Is Promoted", "Total", "Is Free","Action"];

    const getSubscriptions = async () => {
        try {
            setFilter((prev) => ({ ...prev, isLoading: true }));

            const response = await ApiService.get(`/cms/subscriptions?page=${filter.page}&limit=${filter.limit}&name=${filter.search}`);
           
            setFilter((prev) => ({ ...prev, pages: response?.totalPages || 0 }));

            const subscriptionList =  response?.contents?.map((sub) => ({
                _id: sub?._id,
                name: sub?.data?.name,
                type: sub?.data?.type,
                status: sub?.data?.status,
                discount: sub?.data?.discount,
                promotion: sub?.data?.promotion,
                total: sub?.data?.total,
                free: sub?.data?.free
            })) || []

            setSubscriptions(subscriptionList);

        } catch (err) {
            console.error("Error fetching subscriptions:", err);
        } finally {
            setFilter((prev) => ({ ...prev, isLoading: false }));
        }
    };

    useEffect(() => {
        if (!filter.isLoading) {
            getSubscriptions();
        }
    }, [filter?.page, filter?.search]);
    

    return (
        <div className="tyn-root dashboard">
            <Nav />
            <div className="tyn-content tyn-content-full-height tyn-chatbot tyn-chatbot-page has-aside-base">
                <DashboardSidebar active="Subscriptions" setter={setActive} />
                <div className={`tyn-main tyn-content-inner ${active && 'main-shown' || ''}`} id="tynMain">
                <ul className="tyn-list-inline d-md-none translate-middle position-absolute start-50 z-1">
                        <li>
                            <button className="btn btn-icon btn-pill btn-white js-toggle-main" onClick={() => setActive(false)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                </svg>
                            </button>
                        </li>
                    </ul>
                    <DinamicTable
                        data={subscriptions}
                        title="Subscriptions"
                        tableColumns={tableColumns}
                        addLink="/dashboard/subscription/add"
                        editLink="/dashboard/subscription/edit/"
                        filter={filter}
                        setFilter={setFilter}
                    />
                </div>
            </div>
        </div>
    );
};

export default SubscriptionList;
